import{useLayoutEffect as e,useEffect as t}from"react";var o="undefined"!=typeof document?e:t;export{o as default};
//# sourceMappingURL=use-isomorphic-layout-effect.esm.js.map
